module.exports = __webpack_public_path__ + "img/choibetLogo.930cd14e.png";